import { UserModel } from '@akin-home/user';
import { DashboardModel } from '../types';
import { createDashboardModel } from './createDashboardModel';

interface Params {
  user: UserModel;
}

export const cloneDashboardForUser =
  ({ user }: Params) =>
  (dashboard: DashboardModel) => {
    return createDashboardModel({
      ...dashboard,
      id: undefined,
      user_id: user.id,
      owner: user.username,
    });
  };
